import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { MetricsBanner } from '../components/MetricsBanner';
import { SectionNav } from '../components/SectionNav';
export function Impact() {
  return <>
      <PageHeader index="05" title="Executive Impact & Capital Metrics Grid" intro="The quantified record. Four headline outcomes that define two decades of finance leadership, each tied to the institution where it was delivered." data-id="element-385" data-mp="103mx1qi207e9" />
      <MetricsBanner data-id="element-386" data-mp="1nsfl70sfpayb" />
      <SectionNav currentIndex="05" data-id="element-387" data-mp="1nrxu0ikmpmx9" />
    </>;
}